<template>
	<div>
		<b-modal
			id="cropper-modal"
			centered
			size="sm"
			ok-title="Сохранить"
			cancel-title="Отмена"
			no-close-on-backdrop
			@close="resetImage"
			@cancel="resetImage"
			@ok="setResult"
		>
			<cropper
				ref="cropper"
				class="cropper"
				:src="rawImg"
				:stencil-props="{
					aspectRatio: 1
				}"
			/>
		</b-modal>
		<FormulateInput
			v-if="showImage"
			ref="imageInput"
			v-model="image"
			type="image"
			upload-behavior="delayed"
			:class="{wrapperClass, 'withPointer': isImageFromUser}"
			:name="context.attributes.name"
			:upload-url="context.attributes.name"
			validation="optional|^mime:image/jpeg,image/png,image/gif"
			validation-name="Фото"
			:validation-messages="{
				'mime': 'Изображение должно быть формата .png/.jpg/.jpeg/.gif',
			}"
			@input="setPreviewImg"
			@file-removed="imgRemoved"
		/>
	</div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper';

export default {
	components: {
		Cropper,
	},
	props: {
		context: {
			type: Object,
			required: true,
		},
		wrapperClass: {
			type: String,
			required: true,
			default: '',
		},
	},
	data() {
		return {
			rawImg: null,
			image: null,
			showImage: false,
		};
	},
	computed: {
		isImageFromUser() {
			const { files } = this.context?.model;
			return files?.length && typeof files[0]?.previewData === 'string' && !files[0]?.previewData?.includes('https');
		},
	},
	watch: {
		image(value) {
			if (value) {
				this.$refs.imageInput?.$el?.addEventListener('click', this.editPreviewImage);
			}
		},
	},
	mounted() {
		this.image = this.context.model;
		this.$nextTick(() => {
			this.showImage = true;
		});
	},
	methods: {
		imgRemoved() {
			this.$refs.imageInput?.$el?.removeEventListener('click', this.editPreviewImage);
		},
		editPreviewImage(event) {
			if (event.target.className === 'formulate-file-image-preview-image' && this.isImageFromUser) {
				this.$bvModal.show('cropper-modal');
			}
		},
		async setPreviewImg(event) {
			await this.context.getValidationErrors().then((res) => {
				const isFile = event.fileList[0] instanceof File;
				if (event?.fileList?.length && !res.hasErrors && isFile) {
					this.rawImg = URL.createObjectURL(event.fileList[0]);
					this.$bvModal.show('cropper-modal');
				}
			});
		},
		resetImage() {
			this.context.model.files[0].removeFile();
		},
		setResult() {
			const { canvas } = this.$refs.cropper.getResult();
			this.context.model.files[0].previewData = canvas.toDataURL();

			canvas.toBlob((blob) => {
				const { name, type } = this.context.model.fileList[0];
				this.context.model.files[0].file = new File([blob], name, { type });
			});
		},
	},
};
</script>
<style lang="scss">
.withPointer {
	.formulate-file-image-preview {
		cursor: pointer;
	}
}

.cropper.vue-advanced-cropper {
	max-height: 70vh;

	img.vue-advanced-cropper__image {
		object-fit: contain;
	}
}
</style>
